var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoTableVipSectionA = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 265 59",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 262,
  height: 56,
  x: 1.5,
  y: 1.5,
  stroke: "#BABCC0",
  strokeWidth: 3,
  rx: 2.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  fillOpacity: 0.1,
  d: "M261 59H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h257a4 4 0 0 1 4 4v51a4 4 0 0 1-4 4Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#AEB1B5",
  d: "m121.237 25.75 3.028 9.158h.119l3.023-9.159h2.318l-4.102 11.637h-2.602l-4.097-11.637h2.313Zm12.609 0v11.636h-2.108V25.749h2.108Zm2.763 11.636V25.749h4.363c.894 0 1.644.167 2.25.5.61.334 1.07.792 1.381 1.375.314.58.472 1.239.472 1.978 0 .746-.158 1.409-.472 1.988a3.365 3.365 0 0 1-1.392 1.37c-.614.33-1.369.494-2.267.494h-2.892V31.72h2.608c.523 0 .951-.091 1.284-.273.333-.182.579-.432.739-.75.162-.318.244-.683.244-1.096a2.35 2.35 0 0 0-.244-1.091 1.666 1.666 0 0 0-.745-.733c-.333-.178-.763-.267-1.29-.267h-1.931v9.875h-2.108Z"
})));
SvgNoTableVipSectionA.viewBox = '0 0 265 59';
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoTableVipSectionA);
export default ForwardRef;